export const eventCodes2503 = ['이벤트2503', '카뱅2503', '요기요2503'];
export const eventCodes2506 = ['이벤트2506', '카뱅2506', '요기요2506'];
export const KAKAO_EVENT_CODE_06 = '카뱅2506';
// 요기요2025_12
export const YOGIYO_EVENT_CODE_2512 = 'YO2512';
